import get from 'lodash/get'
import set from 'lodash/set'

export function paddInPath(obj, path, len) {
  const initValue = get(obj, path, undefined)
  if (initValue) {
    const value = `${initValue}`
    const paddedValue = (Array(len).fill('0').join('') + value).slice(-1 * len)
    set(obj, path, paddedValue)
  }
}

export function getStringPropFromObjectOrNull(obj, key) {
  if (!obj || !key) {
    return null
  }

  return obj && obj[key] && typeof obj[key] === 'string' ? obj[key] : null
}
